import 'slick-carousel';
import { checkDeviceResolution } from '../utils/check-device-resolution';

const $slider = $('.js-slider');
const $sliderProduct = $('.js-slider-product');
const $sliderProductThumbs = $('.js-slider-product-thumbs');
const $sliderProducts = $('.js-slider-products');
const $sliderCollections = $('.js-slider-collections');
const $sliderTestimonials = $('.js-slider-testimonials');
const $sliderDotsMobile = $('.js-slider-dots-mobile');

$sliderProduct.slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  dots: false,
  arrows: false,
  infinite: false,
  asNavFor: '.js-slider-product-thumbs',
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        dots: true,
      },
    },
  ],
});

$sliderProduct.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
  $('.js-slider-product')
    .find('video')
    .each(function () {
      $(this)[0].pause();
    });
});

$sliderProductThumbs.slick({
  slidesToShow: 6,
  slidesToScroll: 1,
  vertical: true,
  dots: false,
  arrows: true,
  infinite: false,
  asNavFor: '.js-slider-product',
  focusOnSelect: true,
  responsive: [
    {
      breakpoint: 1300,
      settings: {
        slidesToShow: 5,
      },
    },
  ],
});

$slider.slick({
  slidesToShow: 4,
  slidesToScroll: 1,
  dots: false,
  arrows: true,
  infinite: true,
  prevArrow:
    '<a href="#" class="slick-prev"><svg width="12" height="32" viewBox="0 0 12 32" fill="none" xmlns="http://www.w3.org/2000/svg"><line x1="11.1007" y1="14.578" x2="1.184" y2="0.578016" stroke="#434343" stroke-width="2"/><line x1="1.184" y1="31.42" x2="11.1007" y2="14.578" stroke="#434343" stroke-width="2"/></svg></a>',
  nextArrow:
    '<a href="#" class="slick-next"><svg width="12" height="32" viewBox="0 0 12 32" fill="none" xmlns="http://www.w3.org/2000/svg"><line x1="11.1007" y1="14.578" x2="1.184" y2="0.578016" stroke="#434343" stroke-width="2"/><line x1="1.184" y1="31.42" x2="11.1007" y2="14.578" stroke="#434343" stroke-width="2"/></svg></a>',
  responsive: [
    {
      breakpoint: 1201,
      settings: {
        dots: true,
        slidesToShow: 3,
      },
    },
    {
      breakpoint: 1024,
      settings: {
        dots: true,
        slidesToShow: 2,
      },
    },
    {
      breakpoint: 767,
      settings: {
        dots: true,
        slidesToShow: 1,
      },
    },
  ],
});

$sliderProducts.slick({
  slidesToShow: 3,
  slidesToScroll: 1,
  dots: false,
  arrows: true,
  infinite: false,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
      },
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1,
        dots: true,
        arrows: false,
        infinite: true,
      },
    },
  ],
});

$sliderCollections.slick({
  slidesToShow: 4,
  slidesToScroll: 1,
  dots: false,
  arrows: true,
  infinite: true,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
      },
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1,
        arrows: false,
      },
    },
  ],
});

$sliderTestimonials.slick({
  dots: true,
  arrows: false,
  infinite: true,
});

$(window).on('load resize orientationchange', function () {
  if (checkDeviceResolution.isDesktop) {
    if ($sliderDotsMobile.hasClass('slick-initialized')) {
      $sliderDotsMobile.slick('unslick');
    }
  } else {
    if (!$sliderDotsMobile.hasClass('slick-initialized')) {
      // Slider Dots Mobile
      $sliderDotsMobile.slick({
        dots: true,
        arrows: false,
        infinite: true,
      });
    }
  }
});
